import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { ITelecomFeePlan } from '../../constants/telecomFeePlans';
import { planApis } from '../../apis/plan/apis';

export interface ITelecomPlanParams {
  telecom: string;
  plan: string;
}

export const telecomQueries = createQueryKeys('telecom', {
  plans: (params: ITelecomPlanParams) => ({
    queryKey: ['plans', params.telecom, params.plan],
    queryFn: async (): Promise<ITelecomFeePlan> => {
      const response = await planApis.getTelecomPlanList(params);
      return response.data;
    },
  }),
});
